import URLSearchParams from "url-search-params"

import slugFromString from "../../../services/utils/slugFromString"

export function openHelpCenter(language) {
  window.location.href = `/${language}/helpcenter?return=${encodeURIComponent(
    window.location.href,
  )}`
}

export function closeHelpCenter(language) {
  const params = new URLSearchParams(window.location.search)
  window.location.href = params.get("return") || `/${language}/`
}

export function queryToUrl(query) {
  const keys = Object.keys(query)
  if (keys.length === 0) return ""
  return `?${keys.map(key => `${key}=${encodeURIComponent(query[key])}`).join("&")}`
}

export function getIdFromUrl(url) {
  return url.substr(url.lastIndexOf("/") + 1)
}

export function articleError(articles, id) {
  const errorMessage = articles.getIn([id, "error"])
  return Boolean(errorMessage)
}

export function isArticleLoaded(articles, id) {
  return (
    id &&
    articles.get(id) &&
    (articles.getIn([id, "data"]) ||
      articles.getIn([id, "error"]) ||
      articles.getIn([id, "loading"]))
  )
}

export function isArticleLoading(articles, id) {
  return (
    id && (!articles.get(id) || !articles.getIn([id, "data"]) || articles.getIn([id, "loading"]))
  )
}

export function findCategory(categories, path) {
  let category = categories
  path.forEach(id => {
    const children = category.childrens || category
    category = children.find(child => id === child.id)
  })

  return category
}

export function findArticle(categories, path, articleId) {
  let category = categories
  path.forEach(id => {
    const children = category.childrens || category
    category = children.find(child => parseInt(id) === child.id)
  })

  return category.articles.find(child => parseInt(articleId) === parseInt(getIdFromUrl(child.url)))
}

export function findPath(categories, id, searchCategory) {
  let arr = (categories.get("data") || []).slice()
  const ans = []

  while (arr.length > 0) {
    const elem = arr.pop()

    if (elem === "up") {
      ans.pop()
    } else {
      ans.push(elem.id)
      if (
        searchCategory &&
        (slugFromString(elem.title) === decodeURIComponent(id) || String(elem.id) === id)
      )
        break
      if (elem.articles.length > 0) {
        // either we search according to numeric id, or slug
        const element = elem.articles.find(
          child =>
            !searchCategory &&
            (decodeURIComponent(id) === slugFromString(child.title) ||
              getIdFromUrl(child.url) === id),
        )
        if (element) {
          ans.push(getIdFromUrl(element.url))
          break
        }
        arr.push("up")
      }

      if (elem.childrens.length > 0) {
        arr.push("up")
        arr = arr.concat(elem.childrens)
      }

      if (elem.childrens.length === 0 && elem.articles.length === 0) {
        arr.push("up")
      }
    }
  }

  return ans
}

function getCategoryFromSlugOrId(categories, categorySlugOrId) {
  let arr = (categories.get("data") || []).slice()
  while (arr.length > 0) {
    const elem = arr.pop()

    if (String(elem.id) === categorySlugOrId || slugFromString(elem.title) === categorySlugOrId) {
      return elem
    }

    arr = arr.concat(elem.childrens)
  }

  return null
}

/** If categorySlugOrId is not defined or not found, searches category of article. */
export function getCategory(categories, categorySlugOrId, articleId) {
  let category
  if (categorySlugOrId) {
    category = getCategoryFromSlugOrId(categories, categorySlugOrId)
  }
  if (!category) {
    category =
      findCategory(categories.get("data"), findPath(categories, String(articleId)).slice(0, -1)) ||
      {}
  }
  return category || {}
}

export function convertSlugToId(restOfUrl, state) {
  if (restOfUrl.indexOf("/") > -1) {
    const urlParts = restOfUrl.split("/")
    const searchCategory = urlParts[urlParts.length - 2] === "category"
    const itemId = urlParts[urlParts.length - 1]
    if (isNaN(itemId)) {
      const { categories } = state.helpCenter
      const ids = findPath(categories, itemId, searchCategory)
      urlParts[urlParts.length - 1] = ids[ids.length - 1]
      if (urlParts[urlParts.length - 3] === "article") {
        // /article/{categorySlug}/{articleSlug} => convert also category slug to id
        const category = getCategoryFromSlugOrId(categories, urlParts[urlParts.length - 2])
        urlParts[urlParts.length - 2] = category.id
      }
      return urlParts.join("/")
    }
  }
  return restOfUrl
}
